import {  Stack, Group,Box } from "@mantine/core";
import { BeneficiaryDocument } from "../types";



interface Props {
  docs: BeneficiaryDocument[];
}

const BeneficiaryDocs = ({ docs }: Props) => {


  return (
    <>
      {
        <Stack  spacing="xs" mb="sm">

                <Group>
                <Stack>
                {docs?.map((doc, index) => {
                            const fileExtension = doc.document.split('.').pop()?.toLowerCase(); // Get the file extension

                            const isImage = ['jpg', 'jpeg', 'png'].includes(fileExtension ?? '');

                            return (
                              <Box key={index}>
                                {isImage ? (
                                 
                               <a href={doc.document} target="_blank">
                                   <img crossOrigin="anonymous" src={doc.document} alt={`supporting-doc-${index}`} width={200} />
                               </a>
                                ) : (
                                  <a href={doc.document} target="_blank" rel="noopener noreferrer">
                                    {doc.document} {index + 1}
                                  </a>
                                )}
                              </Box>
                            );
                          })}

                              </Stack>
                            </Group>
         
        </Stack>
      }

   

      
    </>
  );
};

export default BeneficiaryDocs;
